import React from 'react';
import { TextField } from '@material-ui/core';

const Input = (props: any) => {
   return (
      <TextField
         fullWidth
         required={props.required}
         name={props.name}
         id={props.id}
         type={props.type}
         label={props.required ? props.placeholder : `${props.placeholder} (optional)`}
         variant="outlined"
         helperText={props?.errors[props.name] && props.touched[props.name] && props.errors[props.name]}
         InputLabelProps={
            props.type === 'date'
               ? {
                    shrink: true,
                 }
               : undefined
         }
         margin="dense"
         disabled={props.disabledInputs?.includes(props.name) || props.disabled}
         value={props.type === 'date' ? props.values[props.name] : props.values[props.name]}
         error={props.errors[props.name] && props.touched[props.name]}
         onChange={(e) => {
            props.handleChange(e);
            props.handleChangeCreateUser
               ? props.handleChangeCreateUser(e.target.name, e.target.value, props.setFieldValue)
               : null;
         }}
         onBlur={props.handleBlur}
         onKeyPress={(e) => {
            if (
               (props.regex && !props.regex.test(e.key)) ||
               (props.maxLength && props.values[props.name].length >= props.maxLength)
            ) {
               e.preventDefault();
               e.stopPropagation();
            }
         }}
         inputProps={{
            autoComplete: 'new-password',
         }}
      />
   );
};

export default Input;
